/**
 * @typedef {Object} AuthUserModel
 * @property {number|string|null} [user_id]
 * @property {string|null} [name]
 * @property {string|null} [email]
 * @property {string|null} [phone]
 * @property {string|null} [role]
 * @property {number|string|null} [company_id]
 * @property {string|null} [company_name]
 * @property {string|null} [wilayah]
 * @property {{ name?: string }|null} [company]
 */

const toNullableString = (value) => {
  if (value === null || value === undefined) return null;
  const trimmed = String(value).trim();
  return trimmed ? trimmed : null;
};

/**
 * Normalize user payload from auth/profile endpoints so UI can safely consume
 * company and wilayah fields across employee/admin sessions.
 *
 * @param {Partial<AuthUserModel>|null|undefined} user
 * @returns {AuthUserModel}
 */
export const normalizeUserModel = (user) => {
  const normalized = { ...(user || {}) };
  const companyName =
    toNullableString(user?.company_name) ||
    toNullableString(user?.company?.name);

  normalized.company_name = companyName;
  normalized.wilayah = toNullableString(user?.wilayah);

  if (companyName) {
    normalized.company = { ...(user?.company || {}), name: companyName };
  }

  return normalized;
};

